import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

const routes =[
  {
    path: '/',
    name: 'home',
    title: '山東總會',
    component: Home
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('./views/News.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('./views/About.vue')
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import('./views/Activity.vue')
  },
  {
    path: '/knowledge',
    name: 'knowledge',
    component: () => import('./views/Knowledge.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('./views/Contact.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('./views/Detail.vue')
  },
  {
    path: '/media',
    name: 'media',
    component: () => import('./views/Media.vue')
  },
  {
    path: '/trade',
    name: 'trade',
    component: () => import('./views/Trade.vue')
  },
]

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

export default router
